<template>
  <div class="screen-saver" @click="$emit('updateSaverShow', false);">
    <el-carousel v-if="saverData.protectType === 1" indicator-position="outside" height="100%" :interval="interval">
      <el-carousel-item v-for="(item, index) in imgArr" :key="index">
        <img class="protect-img" :src="qiniuBaseUrl + item">
      </el-carousel-item>
    </el-carousel>
    <video v-if="saverData.protectType === 2" ref="video" class="protect-video" :src="qiniuBaseUrl + videoArr[videoNum]" autoplay></video>
    <div class="tips">点击进入使用导航  &nbsp;<i class="el-icon-arrow-right"></i></div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  props: {
    saverShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      video: null,
      videoNum: 0
    };
  },
  computed: {
    // 七牛图片地址
    qiniuBaseUrl () {
      return this.$store.state.app.qiniuBaseUrl;
    },
    interval () {
      return this.saverData.protectImageRunTime ? Number(this.saverData.protectImageRunTime) * 1000 : 3000;
    },
    // 建筑信息
    buildInfo: {
      get () { return this.$store.state.nav.buildInfo; },
      set (val) { this.$store.commit('nav/set_buildInfo', val); }
    },
    imgArr () {
      let arr = [];
      if (this.saverData.protectImage) {
        arr = JSON.parse(this.saverData.protectImage);
      }
      return arr;
    },
    videoArr () {
      let arr = [];
      if (this.saverData.protectVedio) {
        arr = JSON.parse(this.saverData.protectVedio);
      }
      return arr;
    },
    ...mapState('nav', [
      'saverData'
    ])
  },
  async mounted () {
    this.videoNum = 0;
    console.log('saverData', this.saverData);
    if (this.saverData.protectType === 2) {
      this.video = this.$refs.video;
      this.video.addEventListener('ended', (e) => {
        console.log('ended 播放完成')
        this.videoNum++;
        this.videoNum = this.videoNum % this.videoArr.length;
        this.video.play();
      })
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.screen-saver {
  position: absolute;
  z-index: 1000;
  width: 100%;
  height: 100vh;
  bottom: 0;
  left: 0;
  background: #000;
}
.protect-img {
  height: 100%;
}
.protect-video {
  height: 100%;
}
.tips {
  position: absolute;
  width: 368px;
  height: 80px;
  z-index: 99999;
  font-size: 32px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 45px;
  background: rgba(0, 0, 0, 0.6);
  top: 26px;
  right: 40px;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style lang="scss">
.screen-saver {
  .el-carousel--horizontal {
    height: 100%;
  }
}
</style>
